import _ from 'lodash';
import React from 'react';
import {
  humanReadableGCMandateStatus,
  humanReadableGCInvitationStatus
} from 'ducks/tenancy';

import Button from 'components/Button';

import ToggleFilter from 'components/Filters/ToggleFilter';
import TreeSelect from 'components/Filters/TreeSelect';
import SelectFilter from 'components/Filters/SelectFilter';
import {
  default as DateRangeFilter,
  TopRightFixedCustomOverlay
} from 'components/Filters/DateRangeFilter';
import CapacityFilter from 'components/Filters/CapacityFilter';

import {
  BOOKING_REQUEST_API,
  BOOKING_VERIFICATION_METHOD,
  getBookingStatusGroups,
  getBookingStatusesForStatusGroup,
  RENEWAL_FORM
} from 'ducks/bookings';

import './styles.css';

const statusData = getBookingStatusGroups().map(value => ({
  label: value,
  data: getBookingStatusesForStatusGroup(value).map(status => ({
    label: status,
    key: status
  }))
}));

interface PassedProps {
  locationRef: string;
  setFilter: (field: string, value: any) => void;
  clearFilters: () => void;
  getFilters: any;
  bookingListFilters: {
    roomTypeFilters: any;
    createdByFilters: any;
  };
  bookingTypes: any;
  salesAgents: any;
  bookingOrganisations: any;
  rooms: any;
  floors: any;
  gocardlessMandateStatuses: string[];
  gocardlessInvitationStatuses: string[];
}

class BookingListFilters extends React.Component<PassedProps> {
  clearFilters = () => {
    this.props.clearFilters();
  };

  render() {
    const {
      setFilter,
      rooms,
      floors,
      bookingTypes,
      bookingOrganisations,
      salesAgents,
      gocardlessMandateStatuses,
      gocardlessInvitationStatuses,
      bookingListFilters: {roomTypeFilters, createdByFilters}
    } = this.props;

    const filters: any = this.props.getFilters();

    const roomTypeData = roomTypeFilters.map(roomTypeGroup => ({
      label: roomTypeGroup.name,
      data: roomTypeGroup.roomTypes.map(roomType => ({
        label: roomType.name,
        key: roomType.ref
      }))
    }));

    const bookingTypesData = bookingTypes.map(bookingType => ({
      label: bookingType.name,
      value: bookingType.name
    }));
    const bookingOrganisationsData = bookingOrganisations.map(
      bookingOrganisation => ({
        label: bookingOrganisation.name,
        value: bookingOrganisation.name
      })
    );
    const roomsData = rooms.map(room => ({
      label: room.roomNumber,
      value: room.id
    }));
    const floorsData = floors.map(floor => ({
      label: floor,
      value: floor
    }));
    const salesAgentsData = salesAgents.map(salesAgent => ({
      label: salesAgent,
      value: salesAgent
    }));

    let createdByData = createdByFilters.map(createdBy => ({
      label: createdBy.name,
      value: createdBy.name
    }));

    createdByData.push({
      label: BOOKING_REQUEST_API,
      value: BOOKING_REQUEST_API
    });

    createdByData.push({
      label: RENEWAL_FORM,
      value: RENEWAL_FORM
    });
    const bookingVerificationMethods = _.map(
      BOOKING_VERIFICATION_METHOD,
      (label, value) => ({label, value})
    );
    const gocardlessMandateStatusesData = gocardlessMandateStatuses.map(
      gocardlessMandateStatus => ({
        label: humanReadableGCMandateStatus(gocardlessMandateStatus),
        value: gocardlessMandateStatus
      })
    );
    const gocardlessInvitationStatusesData = gocardlessInvitationStatuses.map(
      gocardlessInvitationStatus => ({
        label: humanReadableGCInvitationStatus(gocardlessInvitationStatus),
        value: gocardlessInvitationStatus
      })
    );

    return (
      <div className="BookingListFilters colab-row-space-between">
        <div className="colab-sidepadding-2">
          <TreeSelect
            label="Room Type"
            data={roomTypeData}
            value={filters.roomTypes}
            onFilterChange={roomTypes => {
              setFilter('roomTypes', roomTypes);
            }}
            classNameForTesting="RoomTypeFilter"
          />
          <ToggleFilter
            label="Dummy Rooms"
            value={filters.dummyRooms}
            onChange={() => setFilter('dummyRooms', !filters.dummyRooms)}
            classNameForTesting="DummyRoomsFilter"
          />
          <TreeSelect
            label="Status"
            data={statusData}
            value={filters.bookingStatuses}
            onFilterChange={bookingStatuses => {
              setFilter('bookingStatuses', bookingStatuses);
            }}
            classNameForTesting="BookingStatusFilter"
          />
          <SelectFilter
            label="Booking Type"
            data={bookingTypesData}
            value={filters.bookingTypes}
            onChange={bookingTypes => setFilter('bookingTypes', bookingTypes)}
            classNameForTesting="BookingTypeFilter"
          />
          <SelectFilter
            label="Booking Organisation"
            data={bookingOrganisationsData}
            value={filters.bookingOrganisations}
            onChange={bookingOrganisations =>
              setFilter('bookingOrganisations', bookingOrganisations)
            }
            classNameForTesting="BookingOrganisationFilter"
          />
          <SelectFilter
            label="Room Number"
            data={roomsData}
            value={filters.rooms}
            onChange={rooms => setFilter('rooms', rooms)}
            classNameForTesting="RoomNumberFilter"
          />
          <SelectFilter
            label="Floor"
            data={floorsData}
            value={filters.floors}
            onChange={floors => setFilter('floors', floors)}
            classNameForTesting="FloorFilter"
          />
          <SelectFilter
            label="Created By"
            data={createdByData}
            value={filters.createdBy}
            onChange={createdBy => setFilter('createdBy', createdBy)}
            classNameForTesting="BookingCreatedByFilter"
          />
          <SelectFilter
            label="Sales Agents"
            data={salesAgentsData}
            value={filters.salesAgents}
            onChange={salesAgents => setFilter('salesAgents', salesAgents)}
            classNameForTesting="BookingSalesAgentsFilter"
          />
          <SelectFilter
            label="Verification Method"
            data={bookingVerificationMethods}
            value={filters.verificationMethod}
            onChange={method => setFilter('verificationMethod', method)}
            classNameForTesting="BookingVerificationMethodFilter"
          />
          <SelectFilter
            label="GC mandate statuses"
            data={gocardlessMandateStatusesData}
            value={filters.gocardlessMandateStatuses}
            onChange={gocardlessMandateStatuses =>
              setFilter('gocardlessMandateStatuses', gocardlessMandateStatuses)
            }
            classNameForTesting="GoCardlessMandateStatusesFilter"
          />
          <SelectFilter
            label="GC invite statuses"
            data={gocardlessInvitationStatusesData}
            value={filters.gocardlessInvitationStatuses}
            onChange={gocardlessInvitationStatuses =>
              setFilter(
                'gocardlessInvitationStatuses',
                gocardlessInvitationStatuses
              )
            }
            classNameForTesting="GoCardlessInvitationStatusesFilter"
          />
          <DateRangeFilter
            label="Arrival"
            fieldName="arrival"
            start={filters.arrivalStart}
            end={filters.arrivalEnd}
            onChange={(dateField, date) => setFilter(dateField, date)}
            classNameForTesting="BookingArrivalDatesFilter"
          />
          <DateRangeFilter
            label="Departure"
            fieldName="departure"
            start={filters.departureStart}
            end={filters.departureEnd}
            onChange={(dateField, date) => setFilter(dateField, date)}
            classNameForTesting="BookingDepartureDatesFilter"
          />
          <DateRangeFilter
            label="Created"
            fieldName="created"
            start={filters.createdStart}
            end={filters.createdEnd}
            overlayComponent={TopRightFixedCustomOverlay}
            onChange={(dateField, date) => setFilter(dateField, date)}
            classNameForTesting="BookingCreatedAtDatesFilter"
          />
          <DateRangeFilter
            label="Stay"
            fieldName="stay"
            start={filters.stayStart}
            end={filters.stayEnd}
            overlayComponent={TopRightFixedCustomOverlay}
            onChange={(dateField, date) => setFilter(dateField, date)}
            classNameForTesting="BookingStayDatesFilter"
          />
          <CapacityFilter
            value={Number(filters.capacity)}
            onChange={newCapacity => setFilter('capacity', newCapacity)}
            classNameForTesting="RoomCapacityFilter"
          />
          <ToggleFilter
            label="Renewal"
            value={filters.isRenewal}
            onChange={() => setFilter('isRenewal', !filters.isRenewal)}
            classNameForTesting="BookingIsRenewalFilter"
          />
          <ToggleFilter
            label="Completed Agreement"
            value={filters.hasCompletedAgreement}
            onChange={() =>
              setFilter('hasCompletedAgreement', !filters.hasCompletedAgreement)
            }
            classNameForTesting="BookingHasCompletedAgreementFilter"
          />
          <ToggleFilter
            label="Early Termination"
            value={filters.hasEarlyTermination}
            onChange={() =>
              setFilter('hasEarlyTermination', !filters.hasEarlyTermination)
            }
            classNameForTesting="BookingHasEarlyTermination"
          />
        </div>
        <div>
          <Button clear onClick={this.clearFilters}>
            Clear all filters
          </Button>
        </div>
      </div>
    );
  }
}

export default BookingListFilters;
